import * as React from 'react';
import { EditStatus } from './EditStatus';

export interface IEditStatusWidgetProps {
    status: EditStatus;
}

export function EditStatusWidget(props: IEditStatusWidgetProps) {
    switch (props.status) {
        case EditStatus.Idle:
            return <></>
        case EditStatus.Saving:
            return <div className="text-muted pt-2"><span role="img" aria-label="See no evil!">🙈</span> speichere ...</div>;
        case EditStatus.Saved:
            return <div className="text-muted pt-2"><span role="img" aria-label="Monkey see!">🙉</span> gespeichert!</div>;
        case EditStatus.Error:
            return <div className="text-muted pt-2"><span role="img" aria-label="Explode">💥</span> fehler beim speichern</div>;
        default:
            throw Error(`Status not handled ${props.status}.`);
    }
}
